module.exports = __webpack_public_path__ + "img/setup_tips.74194971.svg";